import { HttpClient } from "../../../core/request";
import { parse } from "querystring";
import { availableParams } from "../../../core/helper";
import { getRegion, getCity } from "../../../routes/Home/helpers/location";
import "url-search-params-polyfill";
// ------------------------------------
// Constants
// ------------------------------------
export const LOAD_LOCAl_DEALS = "LOAD_LOCAl_DEALS";

// ------------------------------------
// Actions
// ------------------------------------

export const loadLocalDeals = page => {
    return (dispatch, getState) => {
        let url = new URLSearchParams(window.location.search);
        url.set("page", page);
        const keys = Object.keys(parse(url.toString()));
        var cityFound = false;
        var regionFound = false;
        var regionsFound = false;
                
        keys.map(el => {

            if(el.replace(/[\W]+/g, "") == "city") {
                cityFound = true;
            }
            if(el.replace(/[\W]+/g, "") == "region_id") {
                regionFound = true;
              }
              if(el.replace(/[\W]+/g, "") == "regions") {
                regionsFound = true;
              }
    
            if (!availableParams.includes(el.replace(/[\W]+/g, ""))) {              
              url.delete(el);
            }            
        });
        if(!cityFound) {
            var city = getCity()
            if(city)
                url.set("city", city)
        } 
        if(!regionFound) {
            var region = getRegion()
            if(region)
                url.set("region_id", region)
        }
        if(!regionsFound) {
            var region = getRegion()
            if(region)
                url.set("regions[]", region)
        }
        return HttpClient().get("/prepaid_deals?published=true&" + url.toString());
    };
};

export const loadLocationGroup = (deal_id, brand_id) => {
    return () => {
        return HttpClient().get("/prepaid_deals?published=true&group_deal_id=" + deal_id + '&brand_id=' + brand_id);
    }
}

export const actions = {
    loadLocalDeals: loadLocalDeals
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
    [LOAD_LOCAl_DEALS]: (state, action) => state
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
    localDeals: []
};

export default function localDealsReducer(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];

    return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/LocalDeals/modules/localDealsModule.js